import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    onPointerdown: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('focus'))),
    class: "focus-box-container"
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 32))
}